import * as mq from 'styles/mediaQueries';
import { themes, themesV2, themesV3 } from 'styles/themes';

// Fallback minimum screen width for small screens
const MIN_SCREEN_WIDTH = 320;

export const linearInterpolation = (maxInput, minInput, maxWidth, minWidth) => {
    const slope = (maxInput - minInput) / (maxWidth - minWidth);
    let yInterceptor = minInput - slope * minWidth;
    let yInterceptorPosition = true;
    if (yInterceptor < 0) {
        yInterceptor *= -1;
        yInterceptorPosition = false;
    }
    return `calc(${slope * 100}vw ${!yInterceptorPosition ? '-' : '+'} ${yInterceptor.toFixed(2)}px)`;
};

export const responsiveStyles = (styleType, large, medium, small) => `
  ${mq.mediumAndBelow} {
    ${styleType}: ${linearInterpolation(small, medium, MIN_SCREEN_WIDTH, mq.mediumBreakpoint)};
  }
  ${mq.mediumAndUp} {
    ${styleType}: ${linearInterpolation(medium, large, mq.mediumBreakpoint + 1, mq.largeBreakpoint)};
  }
  ${mq.largeAndUp} {
    ${styleType}: ${large}px;
  }
`;

export const setBackgroundColor = (designSystem, setTheme = 'default') => {
    if (designSystem === 'v2') {
        return themesV2[setTheme].background;
    }
    if (designSystem === 'v3') {
        return themesV3[setTheme].background;
    }
    return themes[setTheme].background;
};

export const fontSmoothing = `
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  -moz-osx-font-smoothing: grayscale;
`;
